import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';

import AdminPage from '../AdminPage';
import { AdminPages, buildPageId } from '../AdminLinkUtils';
import { TimeRangeFilter } from '../../filters';
import { FilterContainer } from '../../page-framework';

import { NPointNumPanel, ProcessingTimePanel, TestResultNumPanel } from '../../panels';

const functionName = AdminPages.ServerHealth;
const title = i18n._(t`nGeniusPULSE Server Health`);

export default function ServerHealthPage() {
    return (
        <AdminPage
            breadcrumbs={[{ text: title }]}
            title={title}
            disablePanelPropsInjection
            pageId={buildPageId(functionName)}
            filterElement={
                <FilterContainer>
                    <TimeRangeFilter required options={{ realTime: true }} />
                </FilterContainer>
            }
        >
            <NPointNumPanel />
            <TestResultNumPanel />
            <ProcessingTimePanel />
        </AdminPage>
    );
}
